"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecutorType = exports.executorProfileTypeMap = exports.ExecutorProfileType = exports.ExecutorJobsType = void 0;
var ExecutorJobsType;
(function (ExecutorJobsType) {
    ExecutorJobsType["AwsBatch"] = "awsbatch";
    ExecutorJobsType["GoogleBatch"] = "google-batch";
    ExecutorJobsType["Ignite"] = "ignite";
    ExecutorJobsType["Local"] = "local";
    ExecutorJobsType["Sge"] = "sge";
    ExecutorJobsType["Lsf"] = "lsf";
    ExecutorJobsType["Slurm"] = "slurm";
})(ExecutorJobsType || (exports.ExecutorJobsType = ExecutorJobsType = {}));
var ExecutorProfileType;
(function (ExecutorProfileType) {
    ExecutorProfileType["AwsBatch"] = "foundry_awsbatch";
    ExecutorProfileType["GoogleBatch"] = "foundry_googlebatch";
    ExecutorProfileType["Ignite"] = "foundry_ignite";
    ExecutorProfileType["Local"] = "foundry_local";
    ExecutorProfileType["Sge"] = "foundry_sge";
    ExecutorProfileType["Lsf"] = "foundry_lsf";
    ExecutorProfileType["Slurm"] = "foundry_slurm";
})(ExecutorProfileType || (exports.ExecutorProfileType = ExecutorProfileType = {}));
exports.executorProfileTypeMap = {
    [ExecutorJobsType.AwsBatch]: ExecutorProfileType.AwsBatch,
    [ExecutorJobsType.GoogleBatch]: ExecutorProfileType.GoogleBatch,
    [ExecutorJobsType.Ignite]: ExecutorProfileType.Ignite,
    [ExecutorJobsType.Local]: ExecutorProfileType.Local,
    [ExecutorJobsType.Sge]: ExecutorProfileType.Sge,
    [ExecutorJobsType.Lsf]: ExecutorProfileType.Lsf,
    [ExecutorJobsType.Slurm]: ExecutorProfileType.Slurm,
};
var ExecutorType;
(function (ExecutorType) {
    ExecutorType["Local"] = "local";
    ExecutorType["SGE"] = "sge";
    ExecutorType["LSF"] = "lsf";
    ExecutorType["SLURM"] = "slurm";
})(ExecutorType || (exports.ExecutorType = ExecutorType = {}));
